/**
 * Check if a HTML Element has one of the CSS class listed
 *
 * @param {HTMLElement} elem - The HTML element where to check the CSS class list
 * @param {string[]} cssClasses - List of CSS class names to check
 * @return {boolean} True if the given CSS class list is present on the given HTML element, false otherwise
 */
export function cssClassListOneOf(elem: HTMLElement, cssClasses: string[]): boolean {
  let result: boolean = false;

  cssClasses.some((cssClass: string) => elem?.classList.contains(cssClass) && (result = true));
  return result;
}
